<div class='layout-navbar'>
    <!-- Fila 1: Logo + Título | Botones (centrados absolutos) | Usuario + Compañía -->
    <div class='navbar-row-1'>
        <!-- Sección Izquierda: Logo + wokap + Título -->
        <div class='navbar-left-section'>
            <img ngSrc='/assets/images/wokap-logo.svg' alt='logo' height='40' width='40' class='cursor-pointer' (click)='navigateHome()' />
            <div class='hidden md:flex align-items-center text-xl pl-2 navbar-title-container'>
                <span class='font-semibold text-400 cursor-pointer' (click)='navigateHome()'>wokap</span>
                <div class='separator'></div>
                <span class='font-bold navbar-title-text'>{{ title }}</span>
            </div>
        </div>

        <!-- Sección Centro: Botones de Navegación (Desktop con etiquetas) -->
        <div class='navbar-center-section navbar-center-section--labels hidden xl:flex'>
            @for (navbarItem of navbarItems; track $index) {
                <div class='relative' [attr.data-tour-id]="'tour-' + navbarItem.id"
                     *appPermissionCheck='getOfferActionConfig(navbarItem.permissions ?? [], navbarItem.routerLink)'>
                    <p-button
                            [label]='navbarItem.label | translate'
                            [severity]='navbarItem.active ? "primary" : "secondary"'
                            [rounded]='true'
                            size='small'
                            class='nowrap-button' />
                    @if (navbarItem.badge) {
                        <p-badge
                                severity='danger'
                                class='badge-corner badge-corner--pill'
                                styleClass='badge-dot-md' />
                    }
                </div>
            }
            @if (enableWokapIA) {
                <div class='relative'
                     data-tour-id='tour-wokap-ia'
                     [pTooltip]="'TIKTOK.WOKAP_AI.TOOLTIP' | translate"
                     tooltipPosition='bottom'>
                    <p-button
                            [severity]='isWokapIaActive() ? "primary" : "secondary"'
                            [rounded]='true'
                            size='small'
                            class='nowrap-button'
                            (onClick)='openAiChat()'>
                        <span class='flex align-items-center gap-2'><span>Encuentra tu candidat&#64;</span></span>
                    </p-button>
                </div>
            }
            @if (enableNavigation && !isPlatformUser()) {
                <div class='relative' data-tour-id='tour-navigation-shorts'
                     *appPermissionCheck='getOfferActionConfig([], ["/navigation-shorts"])'>
                    <p-button
                            [label]="'NAVIGATION.SHORTS_TITLE' | translate"
                            [severity]='isNavigationActive() ? "primary" : "secondary"'
                            [rounded]='true'
                            size='small'
                            class='nowrap-button'
                            styleClass='wokap-ia-nav-button'
                            (onClick)='navigate(["/navigation-shorts"])' />
                </div>
            }
        </div>

        <!-- Sección Centro: Botones de Navegación (Tablet/Mobile con iconos) -->
        <div class='navbar-center-section navbar-center-section--icons flex xl:hidden'>
            @for (navbarItem of navbarItems; track $index) {
                <div class='relative'
                     [attr.data-tour-id]="'tour-' + navbarItem.id"
                     [pTooltip]='navbarItem.label | translate'
                     tooltipPosition='bottom'
                     *appPermissionCheck='getOfferActionConfig(navbarItem.permissions ?? [], navbarItem.routerLink)'>
                    <p-button
                            [icon]='navbarItem.icon'
                            [severity]='navbarItem.active ? "primary" : "secondary"'
                            [rounded]='true'
                            size='small'
                            class='nowrap-button' />
                    @if (navbarItem.badge) {
                        <p-badge
                                severity='danger'
                                class='badge-corner badge-corner--pill'
                                styleClass='badge-dot-md' />
                    }
                </div>
            }
            @if (enableWokapIA) {
                <div class='relative'
                     data-tour-id='tour-wokap-ia'
                     [pTooltip]="'TIKTOK.WOKAP_AI.TOOLTIP' | translate"
                     tooltipPosition='bottom'>
                    <p-button
                            [severity]='isWokapIaActive() ? "primary" : "secondary"'
                            [rounded]='true'
                            size='small'
                            class='nowrap-button'
                            (onClick)='openAiChat()'>
                        <i class='pi pi-bolt'></i>
                    </p-button>
                </div>
            }
            @if (enableNavigation && !isPlatformUser()) {
                <div class='relative'
                     data-tour-id='tour-navigation-shorts'
                     [pTooltip]="'NAVIGATION.SHORTS_TITLE' | translate"
                     tooltipPosition='bottom'
                     *appPermissionCheck='getOfferActionConfig([], ["/navigation-shorts"])'>
                    <p-button
                            icon='pi pi-video'
                            [severity]='isNavigationActive() ? "primary" : "secondary"'
                            [rounded]='true'
                            size='small'
                            class='nowrap-button'
                            styleClass='wokap-ia-nav-button'
                            (onClick)='navigate(["/navigation-shorts"])' />
                </div>
            }
        </div>

        <!-- Sección Derecha: Usuario + Compañía -->
    <div class='navbar-right-section'>
        <!-- Botón de Usuario con clase para contorno -->
        <p-button 
            [rounded]='true' 
            [text]='true' 
            (onClick)='navigateToProfile()' 
            styleClass='p-button-icon-only user-avatar-button user-avatar-btn' 
            data-tour-id='tour-user-profile'>
            @if (userAvatar()?.squareSmall) {
                <p-image
                        [src]='userAvatar()?.squareSmall'
                        imageClass='border-circle'
                        width='48'
                        height='48'
                />
            } @else {
                <span class='user-initials'>{{ getUserInitials() }}</span>
            }
        </p-button>
        <span class='font-semibold hidden lg:block cursor-pointer' (click)='navigateToProfile()'>{{ getUsername() | truncate }}</span>
        
        <div class='separator'></div>
        
        <span class='font-semibold hidden lg:block cursor-pointer' (click)='onSidebarMenuToggle()'>{{ companyName() | truncate }}</span>
        <!-- Botón de Empresa con clase para contorno -->
        <p-button 
            icon='pi pi-briefcase' 
            [rounded]='true' 
            severity='secondary' 
            styleClass='company-avatar-btn'
            (onClick)='onSidebarMenuToggle()'>
            <p-image
                    class='absolute top-0 left-0'
                    [src]='companyMedia()?.squareSmall'
                    imageClass='border-circle'
                    width='48' 
                    height='48' />
        </p-button>
    </div>
    </div>

    <!-- Fila 2: Subtítulo (Opcional) -->
    @if (subtitle) {
        <div class='navbar-row-2'>
            <span class='text-base text-500 overflow-hidden text-overflow-ellipsis white-space-nowrap espaciado'>{{ subtitle }}</span>
        </div>
    }
</div>

<p-sidebar [visible]='sidebarMenuVisible()' (visibleChange)='sidebarMenuVisible.set($event)' [showCloseIcon]='false' position='right' styleClass='sidebar-25rem navbar-menu-sidebar'>
    <ng-template pTemplate='header'>
        <div class='flex flex-1 justify-content-between align-items-center'>
      <span>
        <p-button pRipple [text]='true' severity='secondary' type='button' (onClick)='closeSidebarMenu()'
                  icon='pi pi-times' rounded='true' styleClass='p-sidebar-close p-sidebar-icon p-link'></p-button>
      </span>
            <div class='flex flex-1 gap-2 align-items-center justify-content-end'>
                <span class='font-semibold lg:block cursor-pointer' (click)='navigateToProfile()'>{{ companyName() | truncate }}</span>
                <p-button icon='pi pi-briefcase' [rounded]='true' severity='secondary' (onClick)='onSidebarMenuToggle()'>
                    <p-image
                            class='absolute top-0 left-0'
                            [src]='companyMedia()?.squareSmall'
                            width='48' />
                </p-button>
            </div>
        </div>
    </ng-template>
    <div class='flex flex-column' style='height: 100%'>
        <div class='flex-1 overflow-auto'>
            @if (panelMenuVisible()) {
            <p-panelMenu [model]='profileMenuItems' styleClass='w-full pt-3'>
                <ng-template pTemplate='item' let-item>
                    <div class='flex align-items-center justify-content-between px-3 py-4 cursor-pointer'
                         [attr.data-tour-id]="'tour-' + item.id"
                         [class.tutorial-item-disabled]='item.disabled'
                         [pTooltip]="item.state?.tooltipKey ? (item.state.tooltipKey | translate) : ''"
                         tooltipPosition='left'>
                        <div class='flex align-items-center'>
                            @if (item.flag) {
                                <img [ngSrc]='item.flag' height='20' width='20' alt='wokap' />
                            } @else if (item.state?.emoji) {
                                <span style='font-size: 1.2rem; line-height: 1; width: 20px; text-align: center;'>{{ item.state.emoji }}</span>
                            } @else if (item.state?.svgIcon) {
                                <img [ngSrc]='item.state.svgIcon' height='20' width='20' alt='contact' />
                            } @else if (item.state?.showContactIcons) {
                                <div class='flex align-items-center gap-1'>
                                    <i class='pi pi-user' style='font-size: 1rem;'></i>
                                    <i class='pi pi-headphones' style='font-size: 1rem; transform: translateY(-2px);'></i>
                                </div>
                            } @else if (item.icon) {
                                <i [class]='item.icon'></i>
                            } @else {
                                <span style='display:inline-block; width: 20px; min-width: 20px;'></span>
                            }
                            <span class='ml-3'>
                    {{ item.label + '' | translate }}
                  </span>
                        </div>
                        <i *ngIf='item.items' class='pi pi-angle-down ml-auto'></i>
                    </div>
                </ng-template>
            </p-panelMenu>
            }
            <div class='flex justify-content-end flex-wrap'>
                <p-button [text]='true' [plain]='true' (click)='logout()' styleClass='flex pt-4'>
                    <i class='pi pi-download pi-rotate-90'></i>
                    <span class='ml-3'>
                {{ 'LAYOUT.NAVBAR.LOGOUT' | translate }}
              </span>
                </p-button>
            </div>
        </div>
        <div class='flex justify-content-end p-3'>
            <span class='pt-4'>{{ version }}</span>
        </div>
    </div>
</p-sidebar>
